import { Config } from './config.interface';

export const productionConfig: Config = {
  privyAppId: 'clvwrzvit049tejn7zkksautg',
};
